import r from"react";import e from"clsx";var o=function(o){var t=o.className,a=o.children;return r.createElement("footer",{className:e("fg-footer",t)},a)};export{o as FGFooter};
//# sourceMappingURL=FGFooter.js.map
